import { Util } from "@grandvisionhq/forms";
const validateInputField = (required, value, errorMessage, validations, validationsWithErrorMessages, maxLengthValue) => {
  {
    if (!Util.validations.isRequired(value)) {
      return { isValid: false, errorMessage };
    }
  }
  if (maxLengthValue && !Util.validations.maxLength(maxLengthValue)(value)) {
    return { isValid: false, errorMessage };
  }
  if (validations) {
    const isValid = validations.reduce(
      (isValid2, validator) => validator(value) && isValid2,
      true
    );
    return { isValid, errorMessage };
  }
  if (validationsWithErrorMessages) {
    for (const validatorWithErrorMessage of validationsWithErrorMessages) {
      const isValid = validatorWithErrorMessage.validator(value);
      if (!isValid) {
        return { isValid: false, errorMessage: validatorWithErrorMessage.errorMessage };
      }
    }
  }
  return { isValid: true, errorMessage };
};
export {
  validateInputField
};
//# sourceMappingURL=validate-input-field.js.map
